module.exports = {"420102002":"大智街道","420102003":"一元街道","420102004":"车站街道","420102005":"四唯街道","420102006":"永清街道","420102007":"西马街道","420102008":"球场街道","420102009":"劳动街道","420102010":"二七街道","420102011":"新村街道","420102012":"丹水池街道","420102014":"台北街道","420102015":"花桥街道","420102016":"谌家矶街道","420102017":"后湖街道","420102018":"塔子湖街道","420102400":"百步亭花园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420102.json
// module id = 1821
// module chunks = 0